export const AUTO_LOGOUT_DURATIONS = {
  '5 mins': 5 * 60 * 1000,
  '15 mins': 15 * 60 * 1000,
  '1 hour': 60 * 60 * 1000,
  '6 hours': 6 * 60 * 60 * 1000,
  '1 day': 24 * 60 * 60 * 1000,
};

export const DEFAULT_LOGOUT_DURATION_KEY = '15 mins'; // Default to 15 minutes

// Auto logout timestamp tracking
export const LAST_ACTIVITY_TIMESTAMP_KEY = 'autoLogout_lastActivity';
export const MIN_LOGOUT_CHECK_INTERVAL = 5000; // 5 seconds minimum
export const MAX_LOGOUT_CHECK_INTERVAL = 30000; // 30 seconds maximum

// Lock on Resume grace periods (in seconds)
export const LOCK_GRACE_PERIODS = {
  'Immediately': 0,
  '30 seconds': 30,
  '1 minute': 60,
  '5 minutes': 300,
} as const;

export type LockGracePeriodKey = keyof typeof LOCK_GRACE_PERIODS;

export const DEFAULT_LOCK_GRACE_PERIOD_KEY: LockGracePeriodKey = '1 minute';